import InboxPage from '../InboxPage';
export default function SeekerInboxPage() { return <InboxPage role="seeker" />; }
